module.exports = __webpack_public_path__ + "248b6a02ad838e38205521af05d93a79.jpg";